import React from 'react'

const CoreComponent26 = ({softwareinner}) => {
  return (
    <div>
        <div className="">
            <h3 className='h3-heading lh-base '>{softwareinner.title}</h3>
            {softwareinner.childer.map((val, i) => (
              <div className="" key={i}>
                <div>
                  <p className="mt-3 ps-2 lh-base h3-para ">{val.title}</p>
                </div>
              </div>
            ))}
          </div>
    </div>
  )
}

export default CoreComponent26